export enum COUNTER_TYPE {
  PROGRAMS = 'programs',
  NGOS = 'ngos',
}
